/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 27.04.2016.
 */
import BgSlider from './bg-slider';

export default BgSlider;



// WEBPACK FOOTER //
// ./src/containers/BgSlider/index.js